import React, { forwardRef, memo, useRef } from "react";

import { PlayerSelection } from "./components/PlayerSelection";
import { OrcaPropTypes } from "./OrcaPropTypes";
import { OrcaContextProvider } from "./contexts/OrcaContextProvider";
import { LiveDataProvider } from "./contexts/VideoDataContext/LiveDataProvider";
import { FullFeatureStack } from "./contexts/featureStacks/FullFeatureStack";

const OrcaFull = forwardRef(
  (
    {
      uuid,
      video,
      videoStartId,
      onVideoEnded = () => {},
      onVideoRendered = () => {},
      config = {},
      promoEnabled = true,
      isSandbox = false,
      stickyPlayerContext = {},
      orcaDeps
    },
    ref
  ) => {
    const videoProps = {
      onVideoEnded,
      onVideoRendered,
      config,
      promoEnabled,
      isSandbox
    };

    const defaultRef = useRef();
    const orcaRef = ref ?? defaultRef;

    return (
      <OrcaContextProvider
        DataProviderComponent={LiveDataProvider}
        OptionalFeatureStack={FullFeatureStack}
        uuid={uuid}
        video={video}
        videoStartId={videoStartId}
        isSandbox={isSandbox}
        config={config}
        orcaRef={orcaRef}
        stickyPlayerContext={stickyPlayerContext}
        orcaDeps={orcaDeps}
      >
        <PlayerSelection forwardedRef={orcaRef} {...videoProps} />
      </OrcaContextProvider>
    );
  }
);

OrcaFull.displayName = "Orca";

OrcaFull.propTypes = OrcaPropTypes;

const MemoOrca = memo(OrcaFull);

export { MemoOrca as OrcaFull };
